import { openNotification } from "./components/MainLayout/Notification";
import { getAccessToken, getIdpRef, getIdToken } from "./ProtectedRoute";

export function getBaseUrl() {
    var urlSplit = window.location.origin.split('.');
    if (urlSplit.length > 1 && urlSplit[0].includes("accounts")) {
        urlSplit[0] = urlSplit[0].replace("accounts", "api")
        const baseUrlPrefix = urlSplit.join('.')
        return baseUrlPrefix + '/accounts/v1';
    } else {
        return process.env.REACT_APP_API_URL;
    }
}

export function getAdminPortalBaseUrl() {
    var urlSplit = window.location.origin.split('.');
    if (urlSplit.length > 1 && urlSplit[0].includes("accounts")) {
        urlSplit[0] = urlSplit[0].replace("accounts", "login")
        const baseUrlPrefix = urlSplit.join('.')
        return baseUrlPrefix
    } else {
        return process.env.REACT_APP_ADMIN_PORTAL_BASE_URL;
    }
}

export function getCredentiTokenHeaders() {
    return {
        'Content-Type': 'application/json',
        'X-CREDENTI-ACCESS-TOKEN': getAccessToken(),
        'X-CREDENTI-ID-TOKEN': getIdToken(),
        'X-CREDENTI-IDP-REF': getIdpRef()
    }
}

export function displayError(data) {
    if (data.errorSummary) {
        openNotification("error", data.errorCauses.length !== 0 ? data.errorCauses[0]?.errorSummary ?? data.errorCauses[0] : data.errorSummary)
        return false
    }
    return data ? true : false
}

const Urls = {
    loginWithOidc: `client/info`,
    getAllAccounts: `accounts`,
    users: `admin/users`,
    userFilterableFields: `admin/users/filterable-fields`,
    filterUsers: `admin/users/filter`,
    userAccountsLookUp: `users/lookup`
}

export default Urls;
